<template>
  <div class="list" name="list">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" class="demo-inline-form" :model="search_sale">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="渠道人员账号"
              style="width:160px;"
              v-model="search_sale.FAgentAccount"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="渠道人员编号"
              style="width:160px;"
              v-model="search_sale.FAgentId"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="渠道人员姓名"
              style="width:160px;"
              v-model="search_sale.FName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="渠道人员手机"
              style="width:150px;"
              v-model="search_sale.FMobile"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="search_sale.FBlockStatus" placeholder="状态" style="width:140px;" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="0"></el-option>
              <el-option label="冻结" value="1"></el-option>
              <el-option label="注销" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        border
        style="width:100%"
        align="center"
        v-loading="saleLoading"
        :data="sale_list"
        :header-cell-style="{background:'#FAFAFA'}"
        @sort-change="tableSortChange1"
      >
        <el-table-column
          prop="fcreateTime"
          label="创建时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fAgentAccount"
          label="渠道人员账号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fName"
          label="渠道人员姓名"
          align="center">
          <template slot-scope="scope">
            <div>{{ hideRealName(scope.row.fName) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fAgentLevelStr"
          label="身份"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="渠道人员编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMobile"
          label="渠道人员手机"
          align="center">
          <template slot-scope="scope">
            <div>{{ hidePhoneNum(scope.row.fMobile) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="developAgentNum"
          label="发展代理商数（个）"
          align="center">
        </el-table-column>
        <el-table-column
          prop="developChannelNum"
          label="发展渠道员数（个）"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fBlockStatus"
          label="状态"
          :formatter="formatStatus"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          width="200"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <!-- <el-button
                          type="resetPassword"
                          icon='el-icon-refresh'
                          size="mini"
                          v-if="scope.row.fBlockStatus !== 2"
                          @click='handleReset(scope.row,scope.$index,sale_list)'>重置密码</el-button> -->
            <auth-button
              opt="edit"
              type="text"
              v-if="scope.row.fBlockStatus !== 2"
              label="编辑"
              @click.native="handleEdit(scope.row,scope.$index)"></auth-button>
            <auth-button
              type="text"
              opt="freeze"
              v-if="scope.row.fBlockStatus !== 2"
              v-show="scope.row.fBlockStatus !== 1"
              prop="fBlockStatus"
              label="冻结"
              @click.native="handleFreeze(scope.row,scope.$index,sale_list)"></auth-button>
            <auth-button
              type="text"
              opt="unfreeze"
              v-if="scope.row.fBlockStatus == 1"
              prop="fBlockStatus"
              label="解冻"
              @click.native="handleFreeze(scope.row,scope.$index,sale_list)"></auth-button>
            <auth-button
              opt="delete"
              type="text"
              v-if="scope.row.fBlockStatus !== 2"
              label="注销"
              @click.native="onDeleteUser(scope.row,scope.$index,sale_list)"></auth-button>
            <el-button
              type="text"
              v-if="scope.row.fBlockStatus == 2"
              prop="fBlockStatus"
              disabled
            >该用户已注销</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!-- <el-button :plain="true" @click="openMess">重置密码成功，默认为: Aa123456</el-button> -->

    <!-- 编辑业务员界面 -->
    <el-dialog title="" :visible.sync="editOperatorVisible" size="small" @close="closeViewDialog">
      <el-form>
        <el-row>
          <el-form
            label-width="200px"
            ref="basic"
            :model="basic"
            :rules="rule_data">
            <h4>业务员信息修改
              <ViewAccount
                @success="(account)=>{
                  this.basic.fAgentAccount = account.fAgentAccount
                  this.basic.fName = account.fName
                  this.basic.fMobile = account.fMobile
                }"
                :agentId="basic.fAgentId"
                :isReset="editOperatorVisible"
              />
            </h4>
            <el-form-item label="登录账号" prop="fAgentAccount">
              <el-input v-model="basic.fAgentAccount" style="width: 40%" placeholder="登录账号" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="登录密码" prop="fAgentPassword">
                  <el-input v-model="basic.fAgentPassword" type="password" style="width: 40%" placeholder="不填默认为：Aa123456"></el-input>
                </el-form-item> -->
            <el-form-item label="业务员姓名" prop="fName">
              <el-input v-model="basic.fName" style="width: 40%" placeholder="业务员姓名" @focus="needHideInfoInputFocus('fName')"></el-input>
            </el-form-item>
            <el-form-item label="业务员手机" prop="fMobile">
              <el-input v-model="basic.fMobile" style="width: 40%" :disabled="true" placeholder="业务员手机" @focus="needHideInfoInputFocus('fMobile')"></el-input>
            </el-form-item>
          </el-form>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="editOperatorVisible = false">取 消</el-button>
        <el-button icon="el-icon-edit" type="primary" @click="editSubmit" :loading="editLoading">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { hideRealName, hidePhoneNum } from '@/utils/hideSensitiveInfo.js'
import ViewAccount from '@/components/ViewAccount'
import { listZoneChannel, agentDetail, updateSalesInfo, resetSubAg, blockZoneChannel, unblockZoneChannel, deleteZoneChannel, getSalesmanGroup } from '@/api/partner'
import md5 from 'js-md5'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'

export default {
  name: 'ZoneChannelsInfo',
  components: {
    ViewAccount
  },
  data () {
    return {
      sale_list: [],
      domain: 'https://pos.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      salesNum: '',
      staffsNum: '',
      search_group_list: [],
      comeTime: '',
      downCtr: true,
      editOperatorVisible: false,
      totaldata: {},
      // 搜索表单信息
      search_sale: {
        startTime: '',
        endTime: '',
        FAgentAccount: '',
        FMobile: '',
        FName: '',
        FBlockStatus: '',
        pageNo: '',
        pageSize: '',
        totalCount: ''
      },
      basic: {
        fAgentId: '',
        fAgentAccount: '',
        fAgentPassword: '',
        fMobile: '',
        fName: ''
      },
      editForm: {
        FAgentId: '',
        FAgentPassword: '',
        FMobile: '',
        FName: ''
      },
      FBlockStatus: '',
      saleLoading: false,
      staffLoading: false,
      editLoading: false,
      checkLoading: false,
      groupIdDisabledInput: false,
      disabledInput: false,
      dataParam: {},
      // 弹框信息
      addSale: {
        show: false,
        flag: false
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      seloading: false,
      accesss: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      props: {
        label: 'name',
        value: 'name',
        children: 'children'
      },
      rule_data: {
        fAgentPassword: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入真实姓名'))
            } else {
              if (/^[\u4e00-\u9fa5]{2,6}$/.test(value) || value.includes('*')) {
                callback()
              } else {
                callback(new Error('请输入2-6位中文姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        fMobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号码'))
            } else {
              if (!(/^\d{11,11}$/.test(value)) && !value.includes('*')) {
                callback(new Error('请输入11位手机号码'))
              } else {
                callback()
              }
            }
          },
          required: false
        }]
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    /**
       * hideRealName方法提供给页面调用
       */
    hideRealName (phone) {
      return hideRealName(phone)
    },
    /**
       * hidePhoneNum方法提供给页面调用
       */
    hidePhoneNum (phone) {
      return hidePhoneNum(phone)
    },
    handleEdit (row) {
      this.editOperatorVisible = true
      this.editForm.FAgentId = row.fAgentId

      var data = {
        agentId: row.fAgentId
      }
      data = qs.stringify(data)
      agentDetail(data).then((data) => {
        if (data.error_code === '0') {
          this.basic = data.agentInfo
          this.basic.realfName = this.basic.fName
          this.basic.fName = hideRealName(this.basic.fName)
          this.basic.realfMobile = this.basic.fMobile
          this.basic.fMobile = hidePhoneNum(this.basic.fMobile)
        } else {
          this.$message({
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
       * 需要隐藏信息的输入框获取焦点
       */
    needHideInfoInputFocus (type) {
      if (this.basic[type]) {
        this.basic[type] = ''
        this.basic[`real${type}`] = ''
      }
    },
    // 编辑
    editSubmit () {
      var that = this
      var pw = this.basic.fAgentPassword
      this.editForm.FMobile = that.basic.realfMobile || that.basic.fMobile
      this.editForm.FName = that.basic.realfName || that.basic.fName

      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.editLoading = true
        let para = Object.assign({}, this.editForm)
        para = JSON.parse(JSON.stringify(para))
        if (pw && pw.length < 32) { para.password = md5(pw) }
        para = qs.stringify(para)
        updateSalesInfo(para).then(data => {
          that.editLoading = false
          if (data.error_code === '0') {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
            that.editLoading = false
            this.editOperatorVisible = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.editLoading = false
          }
        })
      })
    },
    deleteValid (v) {
      if (v) {
        if (this.table_type === 'sale') {
          this.$refs.addSaleForm.validateField('masterChannelId')
        } else {
          this.$refs.addStaffForm.validateField('masterChannelId')
        }
      }
    },
    dateChange (value) {
      console.log(value)
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_sale.startTime = value[0]
        this.search_sale.endTime = value[1]
      } else {
        this.search_sale.startTime = ''
        this.search_sale.endTime = ''
      }
    },
    changeVCity (item) {
      this.edit_group_list = []
      // this.editSaleForm.f_group_id = '';
      if (!this.editSaleForm.f_city_code) {
        return
      }
      this.getGroup(this.editSaleForm.f_city_code, 'edit')
    },
    changeCity () {
      this.add_group_list = []
      this.addSaleForm.f_group_id = ''
      if (!this.addSaleForm.f_city_code) {
        return
      }
      this.getGroup(this.addSaleForm.f_city_code, 'add')
    },
    handleClick () {
      this.getList()
    },
    transferType (index, row) {
      this.$confirm('转职成功后将不可修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dynamicTags.splice(this.dynamicTags.indexOf('tag'), 1)
        this.$message({
          type: 'success',
          message: '转职成功!'
        })
      })
    },
    // 显示编辑界面
    handleSale (index, row, scope) {
      // this.disabledInput = true;
      this.viewSale.show = true
      // this.getRow(row.f_account_id)
      // this.editSaleForm = Object.assign({}, row);
      // delete this.editSaleForm["f_create_time"];
      // delete this.editSaleForm["f_update_time"];
    },
    handleStaff (index, row) {
      this.viewStaff.show = true
      // this.getRow(row.f_account_id)
    },
    tableSortChange1 (val) {
      if (val.prop !== null) {
        if (val.order === 'descending') {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 1
        } else {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 0
        }
      }
      this.getList()
    },
    closeViewDialog () {
      this.downCtr = true
      // this.$refs['editStaffForm'].resetFields();
    },
    closeDialog () {
      // this.$refs['addStaffForm'].resetFields();
    },
    showViewSDialog () {
      // this.$refs['editStaffForm'].resetFields();
      // this.$refs.editSaleForm.resetFields();
    },
    showViewDialog () {
      // this.$refs['editStaffForm'].resetFields();
      // this.$refs.editStaffForm.resetFields();
      this.viewStaff.flag = true
    },
    showDialog () {
      this.viewStaff.flag = true
    },
    showAddSale () {
      // this.$refs.addSaleForm.resetFields();
    },
    showAddStaff () {
      // this.$refs.addStaffForm.resetFields();
    },
    handleChange (value) {
      this.getFBankAreaPrvince(value)
    },
    setBankName (value) {
      if (this.addStaff.show && !this.addStaff.flag) {
        this.addStaffForm.f_bank_address = ''
        // this.addStaff.flag = false;
      } else if (this.viewStaff.show && !this.viewStaff.flag) {
        this.editStaffForm.f_bank_address = ''
        // this.viewStaff.flag = false;
      }
      let obj = {}
      obj = this.bank_list.find((item) => {
        return item.F_bank_name === value
      })
      if (this.addStaff.show && obj) {
        this.addStaffForm.f_bank_code = obj.F_bank_name_code
        if (this.addStaffForm.f_bank_code && this.addStaffForm.f_bank_city_code) {
          this.getBranchList()
        }
      } else if (this.viewStaff.show && obj) {
        this.editStaffForm.f_bank_code = obj.F_bank_name_code
        if (this.editStaffForm.f_bank_code && this.editStaffForm.f_bank_city_code) {
          this.getBranchList()
        }
      }
      this.addStaff.flag = false
      this.viewStaff.flag = false
    },
    initRouters () {
      // this.$router.push("/saleManager/sales");
      var routes = this.$router.options.routes
      for (var i = 0; i < routes.length; i++) {
        if (routes[i].hidden !== true && routes[i].children && routes[i].children.length) {
          var tempObj = {}
          var module = routes[i]
          var menus = module.children
          tempObj.name = module.name
          tempObj.path = module.path
          tempObj.access = module.path
          tempObj.children = []
          var menuLen = menus.length
          for (var j = 0; j < menuLen; j++) {
            if (menus[j].hidden !== true && menus[j].children && menus[j].children.length) {
              var tempChildObj = {}
              var menu = menus[j]
              var pages = menu.children
              tempChildObj.name = menu.name
              tempChildObj.path = '/' + menu.path
              tempChildObj.access = tempObj.path + '/' + menu.path
              tempChildObj.children = []
              var pagesLen = pages.length
              for (var k = 0; k < pagesLen; k++) {
                if (pages[k].hidden !== true) {
                  var tempPageObj = {}
                  var page = pages[k]
                  tempPageObj.name = page.name
                  tempPageObj.path = '/' + page.path
                  tempPageObj.access = tempObj.path + '/' + menu.path + '/' + page.path
                  tempChildObj.children.push(tempPageObj)
                }
              }
              tempObj.children.push(tempChildObj)
            }
          }
          this.accesss.push(tempObj)
        }
      }
      // var roles = this.$store.state.user.userinfo.f_roles;
      // if (roles.indexOf(6) == -1) {
      //   this.disabledInput = true;
      // }
    },
    toQueryPair (key, value) {
      if (typeof value === 'undefined') {
        return key
      }
      return key + '=' + encodeURIComponent(value === null ? '' : String(value))
    },
    toQueryString (obj) {
      var ret = []
      var that = this
      for (var key in obj) {
        key = encodeURIComponent(key)
        var values = obj[key]
        if (values && values.constructor === Array) { // 数组
          var queryValues = []
          for (var i = 0, len = values.length, value; i < len; i++) {
            value = values[i]
            queryValues.push(that.toQueryPair(key, value))
          }
          ret = ret.concat(queryValues)
        } else { // 字符串
          ret.push(that.toQueryPair(key, values))
        }
      }
      return ret.join('&')
    },
    /**
       * 点击搜索按钮事件
       */
    onSearch () {
      // this.search_sale.pageNo='';
      // this.search_sale.pageSize = '';
      // this.search_sale.totalCount = '';
      // this.search_sale.Count = '';

      this.checkLoading = true
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
       * 改变页码和当前页时需要拼装的路径方法
       * @param {string} field 参数字段名
       * @param {string} value 参数字段值
       */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      query[field] = value

      this.$router.push({
        path: path,
        query: query
      })
    },
    formatStatus (item) {
      return item.fBlockStatus === 0 ? '正常' : (item.fBlockStatus === 1 ? '冻结' : '注销')
    },
    freeStatus (item) {
      if (item.fBlockStatus === 1) {
        this.$jquery(this).removeClass('dsn')
      }
    },
    unfreeStatus (item) {
      if (item.fBlockStatus === 0) {
        this.$jquery(this).removeClass('dsn')
      }
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      // var pageSize = this.sale_list.length;
      this.search_sale.pageNo = page
      this.search_sale.pageSize = this.paginations.pageSize
      this.search_sale.Count = totalCount
      this.onSearch()
    },

    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.salesNum
      var pageNo = this.paginations.pageNum
      this.search_sale.pageSize = size
      this.search_sale.pageNo = pageNo
      this.search_sale.Count = totalCount
      this.onSearch()
    },
    /**
      * 重置密码事件
      */
    handleReset (user, index, list) {
      var id = user.fAgentId
      var data = { FAgentId: id }
      data = qs.stringify(data)
      resetSubAg(data).then((data) => {
        if (user === true) {
          this.sale_list = this.sale_list.filter(function (item, idx) {
            return id.indexOf(item.fAgentId) === -1
          })
        } else {
          list.splice(index, 1)
        }
        this.$message('密码重置成功，默认为：Aa123456')
        this.getList()
      })
    },
    // getFreeze(item) {
    //   var fStatus = item.fStatus;
    //   return fStatus == 0 ? '正常' : (fStatus == 1 ? '冻结' : '注销');
    // },
    /*
      * 冻结/解冻事件
      */
    handleFreeze (user, index, list) {
      var id = user.fAgentId
      var data = { FAgentId: id }
      data = qs.stringify(data)
      var fBlockStatus = user.fBlockStatus
      if (fBlockStatus === 0) {
        this.$confirm('你确认冻结用户 ' + user.fName + ' 么?', '冻结用户', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          blockZoneChannel(data).then((data) => {
            if (user === true) {
              this.sale_list = this.sale_list.filter(function (item, idx) {
                return id.indexOf(item.fAgentId) === -1
              })
            } else {
              list.splice(index, 1)
            }
            this.getList()
          })
        })
      } else {
        this.$confirm('你确认解冻用户 ' + user.fName + ' 么?', '解冻用户', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          unblockZoneChannel(data).then((data) => {
            if (user === true) {
              this.sale_list = this.sale_list.filter(function (item, idx) {
                return id.indexOf(item.fAgentId) === -1
              })
            } else {
              list.splice(index, 1)
            }
            this.getList()
          })
        })
      }
    },
    /**
       * 注销用户事件
       * @param  {object || boolean} user  当前用户信息对象或者为布尔值,为布尔值时，代表是批量删除
       * @param  {number} index 当前用户列表索引
       * @param  {array} list  当前用户列表数组
       */
    onDeleteUser (user, index, list) {
      var id = user.fAgentId
      var data = { FAgentId: id }
      console.log(data)
      data = qs.stringify(data)
      console.log(data)
      this.$confirm('你确定注销用户 ' + user.fName + ' 么?', '注销用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteZoneChannel(data).then((data) => {
          if (user === true) {
            this.sale_list = this.sale_list.filter(function (item, idx) {
              return id.indexOf(item.fAgentId) === -1
            })
          } else {
            list.splice(index, 1)
          }
          this.getList()
        })
      })
    },
    /**
       * 增加业务员
       * @param
       */
    onAdd () {
      if (this.table_type === 'sale') {
        this.addSale.show = true
      } else {
        this.addStaff.show = true
        this.addStaff.selectedOptions = []
        this.bankbranch_list = []
      }
    },
    getGroup (id, type) {
      getSalesmanGroup({
        f_city_code: id
      }).then((data) => {
        if (type === 'search') {
          this.search_group_list = data.data
        } else if (type === 'add') {
          this.add_group_list = data.data
        } else {
          this.edit_group_list = data.data
        }
      })
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * 获取用户信息列表方法
       */
    getList () {
      this.saleLoading = true
      var data = this.formatSearch(this.search_sale)
      data = qs.stringify(data)

      listZoneChannel(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          // if (data.error_msg.indexOf("登录超时") !== -1) {
          //   this.$store.dispatch('remove_userinfo').then(() => {
          //     this.$router.push('/login');
          //   });
          // } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
          // }
        } else {
          this.saleLoading = false
          this.paginations.total = data.totalCount
          this.sale_list = data.list
          this.salesNum = data.totalCount
          // this.search_sale.pageNo = '';
        }
      })
    },
    formatTotalAmount (item) {
      return this.fmoney(item.f_merchant_total_amount / 100, 2)
    },
    formatTotalIncome (item) {
      return this.fmoney(item.f_total_income / 100, 2)
    },
    fmoney (s, n) {
      if (n) {
        n = n > 0 && n <= 20 ? n : 2
      } else {
        n = 0
      }
      // eslint-disable-next-line no-useless-escape
      s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
      var l = s.split('.')[0].split('').reverse()
      var r = s.split('.')[1]
      var t = ''
      for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
      }
      if (r) {
        return t.split('').reverse().join('') + '.' + r
      } else {
        return t.split('').reverse().join('')
      }
    }
  },
  mounted () {
    this.getList()
    // this.initRouters();
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .demo-form-inline {
        display: inline-block;
        float: right;
    }

    .btm-action {
        margin: 20px 0;
        text-align: center;
    }

    .pagination {
        display: inline-block;
    }
    .list{
        padding-left: 16px;
    }
    .tab-tag{
      height:0;
      padding: 0;
      line-height: 0;
      background: transparent;
    }
    .dsn{
        display: none;
    }
.el-button .el-button {
    margin-left: 4px;
}
</style>
